import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, DRAWER_WIDTH } from './Sidebar';
import { TopBar } from './TopBar';

export const MainLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <TopBar sidebarOpen={sidebarOpen && !isMobile} onToggleSidebar={() => setSidebarOpen((p) => !p)} />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} mobile={isMobile} />
      <Box component="main" sx={{
        flexGrow: 1, p: { xs: 2, sm: 3 },
        width: { md: sidebarOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%' },
        transition: 'width 0.2s', bgcolor: 'background.default', minHeight: '100vh',
      }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};
